// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rV_t","delete":"styles_delete__PwLyR","update":"styles_update__1CBku","add":"styles_add__2_3vF"};